import { render, staticRenderFns } from "./exhibition-product-edit.vue?vue&type=template&id=2c1a40b9&scoped=true&"
import script from "./exhibition-product-edit.vue?vue&type=script&lang=js&"
export * from "./exhibition-product-edit.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-product-edit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./exhibition-product-edit.vue?vue&type=style&index=1&id=2c1a40b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1a40b9",
  null
  
)

export default component.exports